import { FC, ReactNode } from "react";

import { useFeatureFlag, FeatureFlag as FeatureFlagType } from "../../hooks/useFeatureFlag";

interface FeatureFlagProps {
  flag: FeatureFlagType;
  children: ReactNode;
  fallback?: ReactNode;
}

export const FeatureFlag: FC<FeatureFlagProps> = ({ flag, children, fallback = null }) => {
  const isEnabled = useFeatureFlag(flag);
  return isEnabled ? <>{children}</> : <>{fallback}</>;
};

export default FeatureFlag;
